import { Link } from "react-router-dom";
import styled from "styled-components";

type Underline = "none" | "hover" | "always";

export interface StyledLinkProps {
  underline: Underline;
}

const underlineStyles: Record<Underline, string> = {
  none: "text-decoration: none;",
  hover: ":hover {text-decoration: underline}",
  always: "text-decoration: underline",
};

export const RouterLink = styled(Link)<StyledLinkProps>`
  ${({ underline }) => underlineStyles[underline]}
`;
